const PHONE_ALLOWED = /^[+\d\s().-]+$/

const isValidPhone = (value: string) => {
    if (!value || !PHONE_ALLOWED.test(value)) return false
    if (value.indexOf('+') > 0 || (value.match(/\+/g) ?? []).length > 1) return false

    const digits = value.replace(/\D/g, '')
    if (value.startsWith('+')) {
        if (digits.startsWith('7')) return digits.length === 11
        return digits.length >= 8 && digits.length <= 15
    }
    if (digits.length === 10) return true
    return digits.length === 11 && (digits.startsWith('7') || digits.startsWith('8'))
}

export type LeadFieldErrors = {
    name: string | null
    phone: string | null
}

export const getNameError = (value: string, touched: boolean): string | null => {
    if (!touched) return null

    const trimmed = value.trim()
    if (!trimmed) return 'Укажите имя.'
    if (trimmed.length < 2) return 'Имя — не меньше 2 символов.'
    if (trimmed.length > 80) return 'Имя — не больше 80 символов.'
    return null
}

export const getPhoneError = (value: string, touched: boolean): string | null => {
    if (!touched) return null
    if (!isValidPhone(value.trim())) return 'Проверьте формат номера.'
    return null
}

export const validateLeadFields = (name: string, phone: string): LeadFieldErrors => ({
    name: getNameError(name, true),
    phone: getPhoneError(phone, true),
})
